import { FC } from 'react';

import { useTranslations } from '@telialt/common-cms/src/useTranslations';

import { ContentSearchItem, ContentSuggestionClickHandler } from '../../../model';
import { SEARCH_TEST_ID } from '../../../test/test-ids';
import { getFullUrl } from '../../../utils/paths';
import { ContentCard } from '../../ContentCard/ContentCard';
import { SectionHeading, SuggestionsCardsWrapper } from '../SearchSuggestions.styles';

type Props = {
    contentItems: ContentSearchItem[];
    onClick?: ContentSuggestionClickHandler;
};

const SEARCH_SUGGESTIONS_CONTENT = 'search-suggestions-content';

export const ContentSuggestions: FC<Props> = ({ contentItems, onClick }) => {
    const { t } = useTranslations();

    return (
        <section data-test={SEARCH_TEST_ID.SUGGESTIONS_CONTENT} aria-labelledby={SEARCH_SUGGESTIONS_CONTENT}>
            <SectionHeading tag="h2" variant="title-100" id={SEARCH_SUGGESTIONS_CONTENT}>
                {t['search.suggestions.content.title']}
            </SectionHeading>
            <SuggestionsCardsWrapper>
                {contentItems.map((contentItem) => {
                    const splitCategories = contentItem.categories?.split(' > ');

                    return (
                        <ContentCard
                            key={contentItem.id}
                            title={contentItem.title}
                            categoryLevel1={splitCategories?.[0]}
                            categoryLevel2={splitCategories?.[1]}
                            url={getFullUrl(contentItem.url)}
                            onClick={(event) => onClick?.(contentItem, event)}
                        />
                    );
                })}
            </SuggestionsCardsWrapper>
        </section>
    );
};
